import { useState } from "react";
import { useRouteLoaderData } from "react-router-dom";

function getSearchRegex(searchTerm) {
	const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	return new RegExp(`(?:\\b${escaped}|(?<=\\W)${escaped}(?=[a-zäöüß-])|\\(${escaped}[^)]*\\))`, "i");
}

const useFilterSearch = (inspections, defaultSort = { label: "Erstellungsdatum", value: "visitDate" }) => {
	const [search, setSearch] = useState("");
	const { office, ...rest } = useRouteLoaderData("root");
	const [sort, setSort] = useState(defaultSort);
	const [filters, setFilters] = useState({
		"filter-active": "all",
		"filter-inspection-type": "all",
	});
	const [order, setOrder] = useState(true);

	let processedInspections = inspections;

	if (search) {
		processedInspections = processedInspections.filter(({ companyId, companyIdFormerly, companyName, values }) => {
			return (
				companyId?.toString?.().startsWith?.(search) ||
				companyIdFormerly?.toString?.().startsWith?.(search) ||
				companyName.match(getSearchRegex(search)) ||
				values?.taetigkeit_beschreibung_ueberlassungals?.match(getSearchRegex(search))
			);
		});
	}

	const activeFilters = Object.entries(filters).filter(([, value]) => value !== "all");
	for (let i = 0; i < activeFilters.length; i++) {
		const [filterKey, filterValue] = activeFilters[i];
		switch (filterKey) {
			case "filter-active":
				processedInspections = processedInspections.filter(({ values }) => {
					const customerId = parseInt(values.kundenundeinsatzort_kunde_kunde__ID, 10);
					const customer = office.kundenliste?.find(({ KUNDENNR }) => KUNDENNR === customerId);
					const addressKey = `${values.kundenundeinsatzort_kunde_strasseundhausnummer}, ${values.kundenundeinsatzort_kunde_plz}, ${values.kundenundeinsatzort_kunde_ort}`;
					const addressObj = customer?.EinsatzAdressen?.find(({ Adresse }) => Adresse === addressKey);
					const jobObj = addressObj?.Berufe?.find(
						({ Berufschluessel }) => Berufschluessel === values.taetigkeit_beschreibung_ueberlassungals__ID,
					);
					return !!jobObj?.aktiv === (filterValue === "active");
				});
				break;
			case "filter-inspection-type":
				processedInspections = processedInspections.filter(({ type }) => {
					return String(type ?? "").toLowerCase() === filterValue;
				});
				break;
		}
	}

	if (sort) {
		processedInspections = processedInspections.sort((a, b) => {
			let valA;
			let valB;
			let result;
			switch (sort.value) {
				case "visitDate":
					valA = new Date(a.visitDate);
					valB = new Date(b.visitDate);
					result = valB - valA;
					break;
				case "dueDate":
					valA = new Date(a.values.followup_date);
					valB = new Date(b.values.followup_date);
					result = valB - valA;
					break;
				case "customerName":
					valA = a.values.kundenundeinsatzort_kunde_kunde;
					valB = b.values.kundenundeinsatzort_kunde_kunde;
					result = valB >= valA ? -1 : 1;
					break;
				case "customerId":
					valA = parseInt(a.values.kundenundeinsatzort_kunde_kunde__ID, 10);
					valB = parseInt(b.values.kundenundeinsatzort_kunde_kunde__ID, 10);
					result = valB - valA;
					break;
				case "job":
					valA = a.values.taetigkeit_beschreibung_ueberlassungals;
					valB = b.values.taetigkeit_beschreibung_ueberlassungals;
					result = valB >= valA ? -1 : 1;
					break;
			}

			return order ? result : result * -1;
		});
	}

	const onSearch = (value) => {
		setSearch(value);
	};
	const onFilter = (value) => {
		setFilters(value);
	};
	const onSort = (value) => {
		setSort(value);
	};
	const onOrder = (value) => {
		setOrder(value);
	};
	return {
		inspections: processedInspections,
		onSearch,
		onFilter,
		filters,
		filtersCount: activeFilters.length,
		onSort,
		sort,
		onOrder,
	};
};
export default useFilterSearch;
